import SendAnnouncement from 'pages/Annoucement/SendAnnouncement';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

const CreateAnnouncementContainer = () => {
    const location = useLocation();
    const { companyId, firstName, lastName } = useSelector((state: RootState) => ({
        companyId: state.user.defaultCompanyId,
        firstName: state.user?.userInfo?.firstName,
        lastName: state.user?.userInfo?.lastName,
    }));
    const group = location.state?.group;
    const defaultValues = {
        title: '',
        message: '',
        companyId,
        data: {
            announcementGroupId: group?.id || null,
            notificationType: 'GENERAL_MESSAGE',
            firstName,
            lastName,
        },
    };
    return <SendAnnouncement defaultValues={defaultValues} />;
};

export default CreateAnnouncementContainer;
